import React from 'react';
export function TermsPage() {
  return <div className="min-h-screen bg-[#0a0a0a] text-white" data-id="element-502">
      <div className="max-w-4xl mx-auto px-6 py-12" data-id="element-503">
        <h1 className="text-4xl font-bold bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent mb-8" data-id="element-504">
          Términos y Condiciones de Uso
        </h1>

        <div className="text-gray-300 space-y-8" data-id="element-505">
          <h2 className="text-2xl font-bold text-white" data-id="element-506">
            Términos y Condiciones de Uso Tarjeta ELITE CREATOR PASS
          </h2>

          <section data-id="element-507">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-508">
              1. NATURALEZA DEL PROGRAMA
            </h3>
            <p className="leading-relaxed" data-id="element-509">
              El presente documento establece los términos y condiciones
              aplicables al uso de la tarjeta de fidelización gratuita
              denominada Elite Creator Pass (en adelante, "la Tarjeta"), la cual
              permite a sus titulares acceder a beneficios, descuentos y
              promociones ofrecidos por comercios afiliados al programa.
            </p>
          </section>

          <section data-id="element-510">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-511">
              2. ACCESO A LA TARJETA
            </h3>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-512">
              <li data-id="element-513">
                La Tarjeta es gratuita y de uso personal e intransferible.
              </li>
              <li data-id="element-514">
                Podrá acceder a ella cualquier persona natural mayor de edad que
                complete el formulario de afiliación correspondiente y califique
                para alguna de las categorías del programa.
              </li>
              <li data-id="element-515">
                El uso de la Tarjeta implica la aceptación plena de estos
                términos y condiciones.
              </li>
            </ul>
          </section>

          <section data-id="element-516">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-517">
              3. BENEFICIOS Y PROMOCIONES
            </h3>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-518">
              <li data-id="element-519">
                Los beneficios ofrecidos pueden incluir: descuentos directos,
                promociones especiales, servicios preferenciales, accesos
                exclusivos, invitaciones a eventos, obsequios u otros
                incentivos, según lo determine cada comercio afiliado.
              </li>
              <li data-id="element-520">
                Cada comercio es el único responsable de aplicar, mantener,
                modificar o cancelar los beneficios que ofrece a los usuarios de
                la Tarjeta.
              </li>
              <li data-id="element-521">
                Los beneficios están sujetos a condiciones particulares propias
                de cada comercio (vigencia, stock, montos mínimos de compra,
                restricciones, etc.).
              </li>
              <li data-id="element-522">
                Los beneficios podrán variar dependiendo de la categoría de la
                tarjeta, lo que será definido por quienes los otorguen.
              </li>
            </ul>
          </section>

          <section data-id="element-523">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-524">
              4. RESPONSABILIDAD DEL PROGRAMA
            </h3>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-525">
              <li data-id="element-526">
                TicketMaestro y su Plataforma Benefika, empresa procesadora de
                La Tarjeta, actúa únicamente como intermediario que conecta a
                los usuarios con comercios y empresas aliadas, sin asumir
                responsabilidad por la calidad, disponibilidad o condiciones de
                los productos o servicios ofrecidos.
              </li>
              <li data-id="element-527">
                En caso de cualquier inconveniente o reclamo relacionado con los
                beneficios, el usuario deberá comunicarse directamente con el
                comercio o empresa correspondiente.
              </li>
            </ul>
          </section>

          <section data-id="element-528">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-529">
              5. CATEGORÍAS DEL PROGRAMA
            </h3>
            <p className="leading-relaxed mb-4" data-id="element-530">
              El programa contempla 4 categorías de tarjeta, que se basan en los
              siguientes criterios:
            </p>
            <div className="space-y-4 ml-4" data-id="element-531">
              <div data-id="element-532">
                <p className="font-semibold text-white mb-1" data-id="element-533">
                  Categoría 1 Estrella:
                </p>
                <p className="text-gray-400" data-id="element-534">
                  Creadores con un mínimo de 5.000 seguidores en Instagram o
                  TikTok y un máximo de 9.999.
                </p>
              </div>
              <div data-id="element-535">
                <p className="font-semibold text-white mb-1" data-id="element-536">
                  Categoría 2 Estrellas:
                </p>
                <p className="text-gray-400" data-id="element-537">
                  Creadores con un mínimo de 10.000 seguidores en Instagram o
                  TikTok y un máximo de 99.999.
                </p>
              </div>
              <div data-id="element-538">
                <p className="font-semibold text-white mb-1" data-id="element-539">
                  Categoría 3 Estrellas:
                </p>
                <p className="text-gray-400" data-id="element-540">
                  Creadores con un mínimo de 100.000 seguidores en Instagram o
                  TikTok y un máximo de 999.999.
                </p>
              </div>
              <div data-id="element-541">
                <p className="font-semibold text-white mb-1" data-id="element-542">
                  Categoría 4 Estrellas:
                </p>
                <p className="text-gray-400" data-id="element-543">
                  Creadores con un mínimo de 1.000.000 seguidores en Instagram o
                  TikTok.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-544">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-545">
              6. VIGENCIA Y MODIFICACIONES
            </h3>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-546">
              <li data-id="element-547">
                La vigencia de la Tarjeta es indefinida, salvo que el usuario o
                la organización emiten renuncien expresamente a su uso. Sin
                embargo, la vigencia caducará en forma automática en el caso que
                el usuario deje de pertenecer a alguna de las categorías del
                programa.
              </li>
              <li data-id="element-548">
                La organización se reserva el derecho de modificar, suspender o
                cancelar el programa o sus términos y condiciones, informando
                oportunamente a los usuarios a través de sus canales oficiales.
              </li>
            </ul>
          </section>

          <section data-id="element-549">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-550">
              7. PROTECCIÓN DE DATOS PERSONALES
            </h3>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-551">
              <li data-id="element-552">
                Al afiliarse, el usuario autoriza el tratamiento de sus datos
                personales conforme a la legislación vigente, exclusivamente
                para fines informativos y promocionales relacionados con el
                programa.
              </li>
              <li data-id="element-553">
                Los datos no serán compartidos con terceros sin consentimiento
                del titular, salvo requerimiento legal. Puede ver más detalles
                en el documento de nuestras Políticas de Privacidad y Protección
                de Datos Personales.
              </li>
            </ul>
          </section>

          <section data-id="element-554">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-555">
              8. USO INDEBIDO Y CANCELACIÓN
            </h3>
            <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-556">
              <li data-id="element-557">
                El uso fraudulento, indebido o contrario a estos términos puede
                dar lugar a la anulación inmediata de la Tarjeta y la pérdida de
                sus beneficios.
              </li>
              <li data-id="element-558">
                La organización podrá retirar o suspender la tarjeta en caso de
                mal uso sin necesidad de notificación previa.
              </li>
            </ul>
          </section>

          <section data-id="element-559">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-560">9. VIGENCIA</h3>
            <p className="leading-relaxed" data-id="element-561">
              La vigencia de estos Términos y Condiciones de Uso es desde el 12
              de septiembre de 2025 y permanecerá vigente hasta que exista una
              nueva versión que la reemplace.
            </p>
          </section>
        </div>
      </div>
    </div>;
}